import { render } from "./InputText.vue?vue&type=template&id=21456dbc&scoped=true"
import script from "./InputText.vue?vue&type=script&lang=ts"
export * from "./InputText.vue?vue&type=script&lang=ts"

import "./InputText.vue?vue&type=style&index=0&id=21456dbc&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-21456dbc"

export default script